if (!customElements.get("component-calories")) {
  class ComponentCalories extends HTMLElement {
    constructor() {
      super();

      this._loading = true;
      this._isResultPage = false;

      this.pages = [];
      this.templates = {};

      this.configuration = JSON.parse(
        document.querySelector("[data-calorie-configuration]").innerText
      );

      if (this.configuration.calculator_type == "calories") {
        this.calculator = new CaloriesCalculator(this.configuration.formulas);
      } else {
        this.calculator = new BMICalculator(this.configuration.formulas);
      }

      this.caloriesInputFactory = new CaloriesInputFactory(
        this.calculator,
        () => {
          this.valueChangedHandler();
        },
        (pageIndex) => {
          this.currentPage = pageIndex;
        }
      );

      this.recommendationFactory = new CaloriesRecommendationFactory(
        this.configuration.recommendations
      );

      this.recommendationFactory.setCalculator(this.calculator);

      this.inputs = [];

      this._currentPage = 0;
      this.maxPage = null;

      this.resultPage = this.querySelector("[data-result-page]");

      this.skeleton = this.querySelector("[data-skeleton]");
      this.caloriesPagesContainer = this.querySelector(
        "[data-calories-pages-container]"
      );
      this.caloriesPages = this.querySelector("[data-calories-pages]");

      this.navigation = this.querySelector("[data-navigation]");

      this.currentPageContainer = this.querySelector("[data-current-page]");
      this.maxPageContainer = this.querySelector("[data-max-page]");

      this.progressbar = null;
      this.pageInfoContainer = this.querySelector(
        ".page-calories-pages__navigation-info"
      );
      this.prev = this.querySelector("[data-prev]");
      this.next = this.querySelector("[data-next]");
      this.submit = this.querySelector("[data-submit]");

      this.info_message = this.querySelector('.calories-new__info');

      this.prev.addEventListener("click", this.handlePrev.bind(this));
      this.next.addEventListener("click", this.handleNext.bind(this));
      this.submit.addEventListener("click", this.handleSubmit.bind(this));
      this.addEventListener('keydown', (event) => this.handleKeyPress(event));

      this.init();
    }

    set loading(loading) {
      this.skeleton.classList.toggle("hidden", !loading);
      this.caloriesPagesContainer.classList.toggle("hidden", loading || this.isResultPage);
      this.resultPage.classList.toggle("hidden", loading || !this.isResultPage);
      this._loading = loading;
    }

    get loading() {
      return this._loading;
    }

    set isResultPage(isResultPage) {
      this._isResultPage = isResultPage;
    }

    get isResultPage() {
      return this._isResultPage;
    }

    set currentPage(page) {
      this._currentPage = page;

      this.caloriesPages.querySelectorAll(".calories-page").forEach((pageElement) => {
        pageElement.classList.remove("active");
      });
      this.caloriesPages
        .querySelector(`.calories-page[data-page="${this.currentPage}"]`)
        .classList.add("active");

      if (!this.progressbar) {
        this.progressbar = this.querySelector("[data-progressbar]");
      }

      const progressBarAbsoluteWidth = this.progressbar.getBoundingClientRect().width;

        
        
      if (this.configuration.new_style) {
        this._progressCategory();
        const progressCategories = this.querySelector('.calories-new__progress-categories');
        const progressChildren = Array.from(progressCategories.children);
        const currentProgress = this.pages[this.currentPage].progress_category;
    
        progressChildren.forEach((child, index) => {
            child.dataset.active = index < currentProgress ? 'true' : 'false';
        });
    
        if (currentProgress >= 1 && currentProgress <= 4) {
            const targetChild = progressChildren[currentProgress - 1];
            const { left: childLeft, width: childWidth } = targetChild.getBoundingClientRect();
            const { left: parentLeft } = progressCategories.getBoundingClientRect();
            const progressWidth = `${childLeft + (childWidth / 2) - parentLeft}px`;
    
            this.progressbar.style.setProperty("--width", progressWidth);
        }

        this._swapInfoMessage(this.caloriesPages.querySelector(`.calories-page[data-page="${this.currentPage}"]`))
      } else {
      this.progressbar.style.setProperty(
        "--width",
        `${progressBarAbsoluteWidth / (this.maxPage + 1)}px`
      );
      this.progressbar.style.setProperty(
        "--left",
        `${
          this.currentPage * (progressBarAbsoluteWidth / (this.maxPage + 1))
        }px`
      );
      }

      this.currentPageContainer.innerText = this.currentPage + 1;
      const pageSlideWidth = this.querySelector('.calories-page').getBoundingClientRect().width;
      this.caloriesPages.style.transform = `translateX(${this.currentPage * pageSlideWidth * -1}px)`;

      this._updateNavigationButtons();
    }

    _updateNavigationButtons() {
      const isFirstPage = this._currentPage === 0;
      const isLastPage = this._currentPage === this.maxPage;
      const isSinglePage = this.maxPage === 0;

      this.prev.classList.toggle("hidden", isFirstPage);
      this.next.classList.toggle("hidden", isLastPage);
      this.submit.classList.toggle("hidden", !isLastPage);

      this.pageInfoContainer.classList.toggle("hidden", isSinglePage);
      this.navigation.classList.toggle('centered', isSinglePage);
    }

    get currentPage() {
      return this._currentPage;
    }

    async init() {
      await this._loadPages();
      await this._loadTemplates();
      await this._preparePages();
      await this._injectInitial();
      await this._attachListeners();

      this.maxPageContainer.innerText = this.maxPage + 1;

      this.loading = false;
      this.currentPage = 0;

      if (this.configuration.new_style) {
        this._progressCategory();
      }
    }

    hideInfoMessage() {
      this.info_message.classList.remove('show');
      setTimeout(() => {
        this.info_message.style.display = 'none';
      }, 500);
    }
    
    handleNext(e) {
      if (this.calculator.pageValid(this.pages[this.currentPage])) {
        this.currentPage =
          this.maxPage == this.currentPage
            ? this.maxPage
            : this.currentPage + 1;
        this.hideInfoMessage();
      } else {
        this._triggerCurrentPageInvalid();
      }
    }
    
    handlePrev(e) {
      this.currentPage = this.currentPage == 0 ? 0 : this.currentPage - 1;
      this.hideInfoMessage();
    }
    
    _swapInfoMessage(page) {
      const inputs = page.querySelectorAll('input');
      inputs.forEach((input, index) => {
        input.addEventListener('input', () => {
          const info_message = this.pages[this.currentPage].inputs[index].info_message;
    
          if (info_message) {
            this.info_message.style.display = 'flex';
            this.info_message.classList.add('show');
            this.info_message.querySelector('.calories-new__info-text').textContent = info_message;
          } else {
            this.hideInfoMessage();
          }
        });
      });
    }

    _progressCategory() {
      const categories = this.configuration.progress_categories.split(',');
      const container = this.querySelector('.calories-new__progress-categories');
      container.innerHTML = '';

      categories.forEach((category, index) => {
        const div = document.createElement('div');
        div.textContent = category.trim();
        div.dataset.active = false;

        if (index == 0) {
          div.dataset.active = true;
        }
        
        container.appendChild(div);
      });
    }

    async handleSubmit(e) {
      this.loading = true;

      await this._parseResultPage();

      this.isResultPage = true;
      this.loading = false;

      if (this.configuration.calculator_type == "bmi") {
        this._handleAdditionalBMIStyling();
      }
    }

    handleKeyPress(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        if (!this.next.classList.contains("hidden")) {
          this.next.click();
        } else if (!this.submit.classList.contains("hidden")) {
          this.submit.click();
        }
      }
    }

    _triggerCurrentPageInvalid() {
      const currentPageInputs = this.pages[this.currentPage].inputs;

      currentPageInputs.forEach((input) => {
        this.querySelectorAll(`[name="${input.name}"]`).forEach(element => {
          const inputValue = this.calculator.getValueByTarget(element.dataset.target);
          if (inputValue === null || inputValue === "") {
            element.classList.add('error');
            const errorMessage = element.parentElement.querySelector('p');
            if (errorMessage) {
              errorMessage.style.display = 'block';
            }
          }
        });
      });
    }

    _handleAdditionalBMIStyling() {
      const bmiResultCount = this.querySelector('[data-bmi-result-count]');
      const bmiSliderButton = this.querySelector('[data-slider-button]');
      const result = this.calculator.getResult();
      const buttonWidth = bmiSliderButton.getBoundingClientRect().width;

      const BMI_RANGES = [
        { max: 17, color: 'red', position: '0' },
        { max: 18.5, color: 'yellow', position: `calc(25% - ${buttonWidth}px)` },
        { max: 25, color: 'green', position: `calc(50% - ${buttonWidth}px)` },
        { max: 30, color: 'yellow', position: `calc(75% - ${buttonWidth}px)` },
        { max: Infinity, color: 'red', position: `calc(100% - ${buttonWidth}px)` }
      ];

      const range = BMI_RANGES.find(r => result.bmi <= r.max);
      if (range) {
        bmiSliderButton.classList.add(range.color);
        bmiResultCount.classList.add(range.color);
        bmiSliderButton.style.left = range.position;
      }
    }

    async _parseResultPage() {
      this.calculator.calculate();

      let resultTemplate = "";

      if (this.configuration.calculator_type == "calories") {
        resultTemplate += await this._parseCaloriesResultContent(resultTemplate);
      } else {
        resultTemplate += await this._parseBMIResultContent(resultTemplate);
      }

      let recommendedText =
        await this.recommendationFactory.getRecommendedText();
      let recommendedProduct =
        await this.recommendationFactory.getRecommendedProduct();

      resultTemplate += this.parseTemplate(
        this.templates["result-recommendation"],
        [
          {
            placeholder: "[[TEXT]]",
            value: recommendedText.content,
          },
          {
            placeholder: "[[PRODUCT]]",
            value: recommendedProduct.content,
          },
        ]
      );

      this.resultPage.insertAdjacentHTML(
        "beforeend",
        `<div>${resultTemplate}</div>`
      );

      if (this.configuration.new_style) {
        this._drawCircle()
        
        const calorieInfo = document.createElement('div');
        calorieInfo.classList.add('calories-result-wrapper-info');
        calorieInfo.textContent = this.configuration.circle[0].calorie_info;
        this.querySelector('.calories-result-wrapper').appendChild(calorieInfo);
        
        this._addCaloriesElement();
        this._recommendationTitle();
        this.querySelector('section').classList.add('calories-new__results');

        // Scroll to top of the component
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    async _parseCaloriesResultContent(template) {
      const result = this.calculator.getResult();
      const basicResult = Math.round(this.calculator.getBasicVolume());
      const totalResult = result.kcal;

      template += this.parseTemplate(this.templates["result-head"], []);

      const kcalResult = this._calculateKcalResult(result.target, totalResult, basicResult);

      const macros = [
        { template: "result-calories", placeholder: "[[KCAL]]", value: kcalResult },
        { template: "result-protein", placeholder: "[[PROTEIN]]", value: result.protein },
        { template: "result-carbohydrates", placeholder: "[[CARBOHYDRATES]]", value: result.carbohydrates },
        { template: "result-fat", placeholder: "[[FAT]]", value: result.fat }
      ];

      macros.forEach(macro => {
        template += this.parseTemplate(this.templates[macro.template], [
          { placeholder: macro.placeholder, value: macro.value }
        ]);
      });

      return template;
    }

    _calculateKcalResult(target, totalResult, basicResult) {
      const TARGET_CALCULATIONS = {
        '1': () => `${totalResult}`,
        '2': () => `${totalResult + 200} - ${totalResult + 500}`,
        'default': () => {
          const lowerBound = Math.max(totalResult - 500, basicResult);
          return `${Math.round(lowerBound)} - ${Math.round(lowerBound + 200)}`;
        }
      };

      return (TARGET_CALCULATIONS[target] || TARGET_CALCULATIONS['default'])();
    }

    _drawCircle() {
      const canvas = document.querySelector('#calories-new__circle');
      if (!canvas) return;
    
      const result = this.calculator.getResult();
      const settings = this.configuration.circle[0];
    
      // Get the device pixel ratio
      const dpr = window.devicePixelRatio || 1;
    
      // Set the desired display size of the canvas
      const displayWidth = canvas.width;
      const displayHeight = canvas.height;
    
      // Set the canvas internal size to match the CSS size multiplied by the device pixel ratio
      canvas.width = displayWidth * dpr;
      canvas.height = displayHeight * dpr;
    
      const ctx = canvas.getContext('2d');
    
      // Scale the context to ensure correct drawing operations
      ctx.scale(dpr, dpr);
    
      // Create headline for circle element
      const headlineDiv = document.createElement('div');
      headlineDiv.classList.add('h2');
      headlineDiv.textContent = settings.headline;
    
      // Create expandable elements for explanation
      const proteinElement = this._createExpandable(settings.title_protein, result.protein, settings.text_protein, settings.color_protein);
      const carbsElement = this._createExpandable(settings.title_carbs, result.carbohydrates, settings.text_carbs, settings.color_carbs);
      const fatElement = this._createExpandable(settings.title_fat, result.fat, settings.text_fat, settings.color_fat);
    
      const total = result.protein + result.carbohydrates + result.fat;
      const proteinPercent = (result.protein / total) * 100;
      const carbohydratesPercent = (result.carbohydrates / total) * 100;
      const fatPercent = (result.fat / total) * 100;
      
      canvas.style.display = "block";
      
      const centerX = displayWidth / 2;
      const centerY = displayHeight / 2;
      const radius = 120;
      
      const startAngle = (Math.PI / 180) * (-90 - settings.degree / 2);
      const fullCircle = (Math.PI / 180) * settings.degree;
      
      let currentAngle = startAngle;
    
      const drawSegment = (percent, color) => {
        const endAngle = currentAngle + (fullCircle * (percent / 100));
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, currentAngle, endAngle);
        ctx.lineWidth = 12;
        ctx.strokeStyle = color;
        ctx.lineCap = 'round';
        ctx.stroke();
        currentAngle = endAngle;
      };
    
      drawSegment(proteinPercent, settings.color_protein);
      drawSegment(carbohydratesPercent, settings.color_carbs);
      drawSegment(fatPercent, settings.color_fat);
    
      // Function to draw an image at an angle
      const drawImageAtAngle = (imgSrc, angleOffset) => {
        const img = new Image();
        img.onload = function () {
          const angle = startAngle + angleOffset * fullCircle;
          
          const imgSize = 30;
          let drawWidth = imgSize;
          let drawHeight = imgSize;
          
          const x = centerX + (radius - 38) * Math.cos(angle) - drawWidth / 2;
          const y = centerY + (radius - 38) * Math.sin(angle) - drawHeight / 2;
          
          ctx.drawImage(img, x, y, drawWidth, drawHeight);
        };
        img.src = imgSrc;
      };
    
      // Draw images for each macronutrient
      drawImageAtAngle(settings.image_protein, proteinPercent / 100 / 2);
      drawImageAtAngle(settings.image_carbs, (proteinPercent + carbohydratesPercent / 2) / 100);
      drawImageAtAngle(settings.image_fat, (proteinPercent + carbohydratesPercent + fatPercent / 2) / 100);
    
      // Draw title and subtitle in the center
      const maxWidth = 110; // Set the maximum width for title and subtitle
      
      const drawText = (text, y, fontSize, isBold = false) => {
        ctx.font = `${isBold ? 'bold ' : ''}${fontSize}px Arial`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillStyle = '#32323A';
        
        let currentFontSize = fontSize;
        let textWidth = ctx.measureText(text).width;
        
        while (textWidth > maxWidth && currentFontSize > 10) {
          currentFontSize--;
          ctx.font = `${isBold ? 'bold ' : ''}${currentFontSize}px Arial`;
          textWidth = ctx.measureText(text).width;
        }
        
        ctx.fillText(text, centerX, y, maxWidth);
      };
      
      drawText(settings.title, centerY - 10, 20, true);
      drawText(settings.subtitle, centerY + 10, 14);
    
      // Add new elements to circle
      if (canvas && canvas.parentNode) {
        canvas.parentNode.insertBefore(headlineDiv, canvas);
        canvas.parentNode.appendChild(proteinElement);
        canvas.parentNode.appendChild(carbsElement);
        canvas.parentNode.appendChild(fatElement);
      }
    }
    

    // Create expandable elements for nutrient details
    _createExpandable(title, amount, text, color) {
      const container = document.createElement('div');
      container.classList.add('calories-new__expandable');
    
      const wrapper = document.createElement('div');
      wrapper.classList.add('calories-new__expandable-wrapper');
    
      const titleDiv = document.createElement('div');
      titleDiv.classList.add('calories-new__expandable-title');
    
      const circle = document.createElement('span');
      circle.style.backgroundColor = color;
    
      const titleText = document.createElement('span');
      titleText.textContent = `${amount} g ${title}`;
    
      titleDiv.appendChild(circle);
      titleDiv.appendChild(titleText);
      wrapper.appendChild(titleDiv);
    
      const arrow = document.createElement('span');
      arrow.classList.add('calories-new__arrow');
      arrow.innerHTML = `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 9L12 15L18 9" stroke="#32323A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;
      wrapper.appendChild(arrow);
    
      const contentDiv = document.createElement('div');
      contentDiv.classList.add('hidden', 'calories-new__expandable-body');
    
      const innerTitle = document.createElement('div');
      innerTitle.classList.add('h3');
      innerTitle.textContent = title;
    
      const innerText = document.createElement('p');
      innerText.innerHTML = text;
    
      contentDiv.appendChild(innerTitle);
      contentDiv.appendChild(innerText);
      container.appendChild(wrapper);
      container.appendChild(contentDiv);
    
      container.addEventListener('click', () => {
        if (window.innerWidth < 1000) {
          document.querySelectorAll('.calories-new__expandable .calories-new__expandable-body').forEach(body => {
            if (body !== contentDiv) {
              body.classList.add('hidden');
              body.parentNode.querySelector('.calories-new__arrow svg').style.transform = 'rotate(0deg)';
            }
          });
          contentDiv.classList.toggle('hidden');
          arrow.querySelector('svg').style.transform = contentDiv.classList.contains('hidden') ? 'rotate(0deg)' : 'rotate(180deg)';
        }
      });
    
      if (window.innerWidth >= 1000) {
        contentDiv.classList.remove('hidden');
        arrow.querySelector('svg').style.transform = 'rotate(180deg)';
      }
    
      return container;
    }

    _createVolumes(title, calories, text) {
      const volume = document.createElement('div');
      volume.classList.add('calories-new__volume');

      const titleElem = document.createElement('div');
      titleElem.textContent = `${title}: ${Math.round(calories)} kcal`;

      const textElem = document.createElement('div');
      textElem.textContent = text;

      volume.appendChild(titleElem);
      volume.appendChild(textElem);

      return volume;
    }

    _createShowMore(text) {
      if (typeof text !== 'string') return null;
    
      const div = document.createElement('div');
      div.classList.add('calories-new__show');
    
      const decodedText = text.replace(/\\u003c/g, '<').replace(/\\u003e/g, '>').replace(/\\u0026/g, '&').replace(/\\/g, '');
      const bracketPattern = /\[(.*?)\](.*)/;
      const match = decodedText.match(bracketPattern);
    
      if (match) {
        const [ , insideBrackets, afterBrackets] = match;
        const [firstPart, secondPart] = insideBrackets.split('|');
    
        const textBeforeBrackets = decodedText.replace(bracketPattern, '');
    
        div.innerHTML = `
          <span>${textBeforeBrackets}</span>
          <span class="calories-new__show-hidden" style="display: none;">${afterBrackets}</span>
          <span class="calories-new__show-first">${firstPart}</span>
          <span class="calories-new__show-second" style="display: none;">${secondPart}</span>
        `;
    
        div.querySelector('.calories-new__show-first').addEventListener('click', () => {
          div.querySelector('.calories-new__show-first').style.display = 'none';
          div.querySelector('.calories-new__show-second').style.display = 'inline-block';
          div.querySelector('.calories-new__show-hidden').style.display = 'inline-block';
        });
    
        div.querySelector('.calories-new__show-second').addEventListener('click', () => {
          div.querySelector('.calories-new__show-first').style.display = 'inline-block';
          div.querySelector('.calories-new__show-second').style.display = 'none';
          div.querySelector('.calories-new__show-hidden').style.display = 'none';
        });
      } else {
        div.innerHTML = decodedText;
      }
    
      return div;
    }

    _addCaloriesElement() {
      const calories = document.querySelector('.calories-result-wrapper');
      if (!calories) return;

      const result = this.calculator.getResult();
      const settings = this.configuration.calories[result.target].settings;
      const basicResult = this.calculator.getBasicVolume();
      // const kcalTarget = this.calculator.getKcalTarget();
      const totalResult = this.calculator.getResult().kcal;
      const showMore = this._createShowMore(settings.paragraph);
      const basicCal = this._createVolumes(settings.title_basic, basicResult, settings.text_basic);
      const totalCal = this._createVolumes(settings.title_total, totalResult, settings.text_total);
    
      const wrapper = document.createElement('div');
      wrapper.classList.add('calories-new__calories-wrapper');

      const volumeWrapper = document.createElement('div');
      volumeWrapper.classList.add('calories-new__calories-volumes');

      volumeWrapper.appendChild(basicCal)
      volumeWrapper.appendChild(totalCal)
    
      wrapper.appendChild(showMore);
      wrapper.appendChild(volumeWrapper);
    
      calories.insertAdjacentElement('afterend', wrapper);
    }

    _recommendationTitle() {
      this.querySelectorAll('.result-recommendation .h2').forEach(el => {
        el.classList.replace('h2', 'h3');
      });

      const h3Elements = this.querySelectorAll('.result-recommendation__text h3');

      h3Elements.forEach(h3 => {
        const parent = h3.closest('.result-recommendation').querySelector('.h3');
        if (parent) {
          parent.appendChild(h3);
        }
      });

      h3Elements.forEach(h3 => {
        const div = document.createElement('div');
        div.classList.add('h2');
        div.innerHTML = h3.innerHTML;
        h3.replaceWith(div);
      });
    }

    async _parseBMIResultContent(template) {
      const result = this.calculator.getResult();
      const resultText = await this.recommendationFactory.getResultText();

      const bmiTemplates = [
        { template: "bmi-slider", placeholder: "[[BMI]]", value: result.bmi },
        { template: "bmi-result", placeholder: "[[TEXT]]", value: resultText.content },
        { template: "bmi-calculation-result", placeholder: "[[BMI]]", value: result.bmi }
      ];

      bmiTemplates.forEach(item => {
        template += this.parseTemplate(this.templates[item.template], [
          { placeholder: item.placeholder, value: item.value }
        ]);
      });

      return template;
    }

    async _loadPages() {
      document
        .querySelectorAll("[data-page]")
        .forEach((page) => this.pages.push(JSON.parse(page.innerText)));
      this.maxPage = this.pages.length - 1;
    }

    async _loadTemplates() {
      await fetch(`${window.Shopify.routes.root}?section_id=calorie-counter-page-templates`)
        .then((response) => response.text())
        .then((html) => {
          let templates = new DOMParser().parseFromString(html, "text/html");
          let types = templates.querySelectorAll("[calories-type]");
          types.forEach((type) => {
            this.templates[type.dataset.type] = type.innerHTML;
          });
        });
    }

    async _preparePages() {
      this.pages = this.pages.map((page, pageIndex) => {
        let parsedHTML = "";

        if (page.title) {
          parsedHTML += this.parseTemplate(this.templates["heading"], [
            {
              placeholder: "[[HEADING_SIZE]]",
              value: page.heading_size,
            },
            {
              placeholder: "[[TITLE]]",
              value: page.title,
            },
          ]);
        }

        if (page.text) {
          parsedHTML += this.parseTemplate(this.templates["subheading"], [
            {
              placeholder: "[[TEXT]]",
              value: page.text,
            },
          ]);
        }

        page.inputs.forEach((input) => {
          parsedHTML += this.parseInput(input.type, input, pageIndex);
        });

        let pageTemplate = this.parseTemplate(this.templates["page"], [
          {
            placeholder: "[[CONTENT]]",
            value: parsedHTML,
          },
          {
            placeholder: "[[INDEX]]",
            value: pageIndex,
          },
        ]);
        return {
          ...page,
          html: pageTemplate,
        };
      });
    }

    async _injectInitial() {
      this.pages.forEach((page) => {
        this.caloriesPages.insertAdjacentHTML("beforeend", page.html);
      });
    }

    async _attachListeners() {
      const inputs = {};
      this.pages.forEach((page) => {
        page.inputs.forEach((input) => {
          if (!inputs[input.target]) {
            inputs[input.target] = {
              e: null,
              name: input.name,
            };
          }
        });
      });

      this.caloriesInputFactory.setInputs(inputs);
      this.caloriesInputFactory.init();

      window.addEventListener("resize", debounce(() => {
        const pageSlideWidth = this.querySelector('.calories-page').getBoundingClientRect().width;
        this.caloriesPages.style.transform = `translateX(${this.currentPage * pageSlideWidth * -1}px)`;
      }, 100));
    }

    valueChangedHandler() {
      this.submit.disabled = !this.calculator.valid();
    }

    parseTemplate(template, data) {
      return data.reduce((parsed, { placeholder, value }) =>
        parsed.replaceAll(placeholder, value), template
      );
    }

    parseInput(type, data, pageIndex) {
      const handlers = {
        'select-group': () => this._parseSelectGroup(data, pageIndex),
        'input': () => this._parseInput(data, pageIndex),
        'break': () => this.parseTemplate(this.templates["break"], [])
      };

      return handlers[type]?.() || '';
    }

    _parseSelectGroup(data, pageIndex) {
      const options = data.options
        .map(option => `<option value="${option.factor}">${option.label}</option>`)
        .join('');

      let html = '<div class="clear input-type-select">';

      html += this.parseTemplate(this.templates["label"], [
        { placeholder: "[[REFERENCE]]", value: `${data.name}-${data.factor}` },
        { placeholder: "[[LABEL]]", value: data.label },
        { placeholder: "[[PAGE]]", value: pageIndex }
      ]);

      html += this.parseTemplate(this.templates["select"], [
        { placeholder: "[[OPTIONS]]", value: options },
        { placeholder: "[[NAME]]", value: data.name },
        { placeholder: "[[TARGET]]", value: data.target },
        { placeholder: "[[PAGE]]", value: pageIndex }
      ]);

      html += "</div>";
      return html;
    }

    _parseInput(data, pageIndex) {
      if (data.inputType === "radio") {
        return this._parseRadioInput(data, pageIndex);
      }
      return this._parseStandardInput(data, pageIndex);
    }

    _parseRadioInput(data, pageIndex) {
      return this.parseTemplate(this.templates["radio"], [
        { placeholder: "[[REFERENCE]]", value: `${data.name}-${data.factor}` },
        { placeholder: "[[LABEL]]", value: data.label },
        { placeholder: "[[PAGE]]", value: pageIndex },
        { placeholder: "[[TYPE]]", value: data.inputType },
        { placeholder: "[[TARGET]]", value: data.target },
        { placeholder: "[[FACTOR]]", value: data.factor },
        { placeholder: "[[PLACEHOLDER]]", value: data.placeholder },
        { placeholder: "[[NAME]]", value: data.name },
        { placeholder: "[[LABEL_REFERENCE]]", value: `${data.name}-${data.factor}` },
        { placeholder: "[[ICON]]", value: data.icon || '' },
        { placeholder: "[[ICON_DATA]]", value: data.icon },
        { placeholder: "[[BLOCK_AMOUNTS]]", value: data.block_amounts },
        { placeholder: "[[LABEL_STYLING]]", value: data.label_styling }
      ]);
    }

    _parseStandardInput(data, pageIndex) {
      let html = '';
      if (data.label) {
        html += '<div class="clear input-type-input">';
        html += this.parseTemplate(this.templates["label"], [
          { placeholder: "[[REFERENCE]]", value: `${data.name}-${data.factor}` },
          { placeholder: "[[LABEL]]", value: data.label },
          { placeholder: "[[PAGE]]", value: pageIndex }
        ]);
      }

      const templateType = data.inputType === 'number' ? 'input-number' : 'input';
      const templateArgs = [
        { placeholder: "[[TYPE]]", value: data.inputType },
        { placeholder: "[[TARGET]]", value: data.target },
        { placeholder: "[[FACTOR]]", value: data.factor },
        { placeholder: "[[PLACEHOLDER]]", value: data.placeholder },
        { placeholder: "[[NAME]]", value: data.name },
        { placeholder: "[[LABEL_REFERENCE]]", value: `${data.name}-${data.factor}` },
        { placeholder: "[[PAGE]]", value: pageIndex },
        { placeholder: "[[ERROR_MESSAGE]]", value: data.error_message }
      ];

      if (data.inputType === 'number') {
        templateArgs.push(
          { placeholder: "[[MIN]]", value: data.validation.min },
          { placeholder: "[[MAX]]", value: data.validation.max }
        );
      }

      html += this.parseTemplate(this.templates[templateType], templateArgs);

      if (data.label) {
        html += "</div>";
      }

      return html;
    }

  }

  customElements.define("component-calories", ComponentCalories);
}
